import * as React from 'react';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { appStore } from '../../AppStore';
import { CreateProjectAction, CreateWorkbookAction } from '../Explorer/CreateContent/CreateContentActionsList';

export function newWorkbookButton(): JSX.Element {
  const appState = appStore.getState();
  const createWorkbookAction = CreateWorkbookAction;
  if (createWorkbookAction.isVisible(appState, 'workbook') && createWorkbookAction.isClickable(appState)) {
    const reduxAction = createWorkbookAction.createReduxAction();
    const handleClick = () => appStore.dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newWorkbook()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-workbook'}/>
    );
  }
  return null;
}

export function newProjectButton(): JSX.Element {
  const appState = appStore.getState();
  const createProjectAction = CreateProjectAction;
  if (createProjectAction.isVisible(appState, 'project') && createProjectAction.isClickable(appState)) {
    const reduxAction = createProjectAction.createReduxAction();
    const handleClick = () => appStore.dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newProject()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-project'}/>
    );
  }
  return null;
}
